import { OutboundLink } from "./Map";

export const LinkTo2022Pdf = ({ bbl, referrer }) => {
  if (!!bbl) {
    return (
      <OutboundLink
        className="button"
        to={`https://a836-edms.nyc.gov/dctm-rest/repositories/dofedmspts/StatementSearch?bbl=${bbl}&stmtDate=2023${getDocDate(
          bbl,
          2022
        )}&stmtType=SOA`}
        referrer={referrer}
      >
        See 2022 Tax Bill
      </OutboundLink>
    );
  } else return <></>;
};

export const LinkTo2019Pdf = ({ bbl, referrer }) => {
  if (!!bbl) {
    return (
      <OutboundLink
        className="button"
        to={`https://a836-edms.nyc.gov/dctm-rest/repositories/dofedmspts/StatementSearch?bbl=${bbl}&stmtDate=2020${getDocDate(
          bbl,
          2019
        )}&stmtType=SOA`}
        referrer={referrer}
      >
        See 2019 Tax Bill
      </OutboundLink>
    );
  } else return <></>;
};

/**
 * Given a BBL and a tax bill year (either 2019 or 2022),
 * provide the 4-digit month/day when the tax bill was posted online.
 *
 * These dates were determined by looking at the dates in the `pdfsoa` links in the
 * raw data.
 */
const getDocDate = (bbl, year) => {
  if (year === 2019) {
    return [
      1005210034, 1007220022, 1015170014, 2059530230, 3002310019, 3055480053,
      3065760048, 3074400028, 4022680014, 4031550001, 4045880036, 4045910066,
      4053020083, 4061490001, 4061500001, 4066330001, 4066560063, 4066710001,
      4066760019, 4073470020, 4077480500, 4097150228, 4105240150, 1005170006,
      1005170007, 1006160043, 1006200054, 1006290041, 1006400072, 1006420046,
      1007220020, 1007400048, 1007400050, 1007910068, 1010560048, 1010560051,
      1011420029, 1012100049, 1012190059, 1012470019, 1012470020, 1012470021,
      1012470043, 1012470119, 1012520044, 1013450038, 1013630031, 1013630040,
      1013630043, 1013690033, 1013920046, 1014470037, 1014470047, 1014510038,
      1014510039, 1014890037, 1015110048, 1015270040, 1015330042, 1015340007,
      1015340010, 1015340011, 1015520013, 1015550019, 1015560016, 1015780013,
      1015800033, 1015860013, 1015860035, 1015860043, 1018890043, 1020600046,
      1021770175, 1021800628, 2042890035, 2042890050, 2055170061, 2055170132,
      2059090977, 2059120091, 2059190460, 2059500475, 2059530240, 3002410028,
      3011520062, 3011700041, 3019020001, 3019020022, 3019300001, 3019440004,
      3020610060, 3020610080, 3048530035, 3050430086, 3055480059, 3055480062,
      3057700045, 3058890058, 3061150006, 3067000038, 3067010064, 3067960026,
      3071040144, 3074330034, 3074330040, 3075590059, 3076810010, 3076820016,
      3077780024, 3088060150, 4001780025, 4001980019, 4011320044, 4012650030,
      4012650033, 4012810033, 4014430006, 4014480001, 4014490001, 4014500039,
      4014620001, 4015610012, 4019080001, 4019450001, 4020930245, 4021010001,
      4021010016, 4021010024, 4021520101, 4021520106, 4021550001, 4021660039,
      4022510054, 4022680013, 4022690020, 4022700020, 4033120008, 4033210069,
      4033550136, 4045740061, 4045740071, 4045880001, 4045880023, 4045880024,
      4045880051, 4045910075, 4045910082, 4045910083, 4045910096, 4045910103,
      4045910109, 4045910118, 4045910129, 4046020030, 4046020034, 4046020125,
      4046020131, 4046030002, 4046030018, 4046030032, 4046030034, 4046030048,
      4053000022, 4053030144, 4053110001, 4053140003, 4060890025, 4061430001,
      4064820100, 4064930003, 4064940003, 4065400003, 4065420003, 4066070001,
      4066090007, 4066280001, 4066320001, 4066590021, 4066600040, 4066690007,
      4066690027, 4066760020, 4066790001, 4066900001, 4071170401, 4073420028,
      4073480001, 4073490001, 4077320150, 4077380001, 4077420003, 4077480400,
      4077540003, 4077550003, 4078420033, 4078440002, 4079120050, 4084010675,
      4084460001, 4084500001, 4087620001, 4097580021, 4114460012, 4114460050,
    ].includes(bbl)
      ? "0612"
      : [
          1004080020, 1008740068, 1015240015, 1022240025, 2026750051,
          2029720038, 2032070056, 2033010018, 2037470111, 2048350186,
          2057870177, 3008330066, 3008610054, 3009170020, 3009920040,
          3011050026, 3012520030, 3014850022, 3027020016, 3030550017,
          3032190023, 3032790045, 3032890016, 3033100038, 3034310042,
          3039540014, 3040880015, 3046050038, 3046760026, 3047220013,
          3057700062, 3060440051, 3063630016, 3064100027, 4001280171,
          4006150083, 4006480015, 4006970083, 4006970093, 4007200030,
          4008320084, 4008760003, 4014020036, 4017420025, 4017710030,
          4017800022, 4021830008, 4034850041, 4034850043, 4033940057,
          4034040008, 4034700045, 4036450028, 4084430001, 4155740048,
          1001640006, 1003820001, 1004350040, 1004490051, 1004650020,
          1004950045, 1005180036, 1005860011, 1006220059, 1006310046,
          1007540021, 1008000056, 1008160031, 1008230017, 1008670057,
          1008990001, 1010390005, 1010460062, 1010490001, 1010600035,
          1010650048, 1010817501, 1011690008, 1011830053, 1014460023,
          1015120040, 1015510035, 1017080028, 1019060064, 1019230061,
          1019880033, 1020020033, 1020020091, 1020310012, 1020360064,
          1020460063, 1020770010, 1020770032, 1020870036, 1021420095,
          1021570070, 1021610071, 1021797502, 1021807501, 1022300027,
          2022680006, 2022750001, 2023290162, 2023770056, 2023790032,
          2024100054, 2025340001, 2026470014, 2027240001, 2027620164,
          2028280017, 2029400011, 2029400032, 2029620064, 2030010006,
          2030320058, 2030590061, 2030930047, 2031030065, 2031110039,
          2031170110, 2031270033, 2032010030, 2032120078, 2032370145,
          2033110109, 2033180058, 2033480020, 2033570248, 2037720060,
          2037760036, 2038030005, 2038030019, 2038130012, 2040370028,
          2040710002, 2041720007, 2043250021, 2046170045, 2046640028,
          2046860001, 2046930001, 2048240042, 2048310055, 2048570024,
          2048600010, 2057030183, 2057890015, 2057920430, 3001870009,
          3001870020, 3002340033, 3004070007, 3004760030, 3006450067,
          3006460054, 3022660017, 3007140027, 3007380014, 3007580023,
          3007580050, 3007840050, 3008130015, 3008150031, 3008210069,
          3008400031, 3008410008, 3008500137, 3008610049, 3008610050,
          3008660005, 3008660073, 3008700022, 3008700043, 3008700044,
          3008850052, 3009000036, 3009140056, 3009690048, 3010020029,
          3010030126, 3010560012, 3010610009, 3011130003, 3011370053,
          3011740063, 3011770041, 3011990001, 3012000067, 3012200028,
          3012270076, 3012340001, 3012370005, 3012400004, 3012430026,
          3012520085, 3013050068, 3013190006, 3013230017, 3013440119,
          3013770010, 3013870062, 3014850021, 3014850046, 3015020018,
          3015350010, 3015350056, 3015400053, 3015520004, 3015650006,
          3016370042, 3017570022, 3017690055, 3017750020, 3017770033,
          3018060016, 3018920024, 3019160032, 3019420036, 3019620082,
          3023210033, 3024160001, 3024320040, 3024330032, 3024680026,
          3025130027, 3025330030, 3025750006, 3025980030, 3026220025,
          3026220051, 3026450029, 3026510021, 3026520035, 3026550047,
          3026860031, 3026890074, 3027450032, 3027540013, 3027590015,
          3027680035, 3027890002, 3027920036, 3030450019, 3030520011,
          3031700026, 3031740006, 3031830023, 3031870011, 3031960025,
          3031970020, 3031970052, 3031990006, 3031990037, 3032010007,
          3032110029, 3032190024, 3032200049, 3032280009, 3032580027,
          3032690018, 3032790041, 3032790048, 3032800034, 3032800036,
          3032820041, 3032920008, 3032920014, 3032970038, 3033120022,
          3033120025, 3033120027, 3033190022, 3033210039, 3033300014,
          3033420026, 3033530011, 3033540009, 3033630030, 3034130023,
          3034190007, 3034250038, 3034250061, 3034330004, 3034370042,
          3034430021, 3034470030, 3034470033, 3058770016, 3036000049,
          3036250040, 3037920016, 3038250051, 3038260001, 3039170022,
          3039550033, 3040870009, 3041040044, 3041190063, 3041280007,
          3041280008, 3041350001, 3043030017, 3043030077, 3043130045,
          3046140043, 3046360032, 3046380041, 3046490054, 3046590010,
          3046600021, 3046600024, 3047140011, 3047190020, 3047230009,
          3047230019, 3048530009, 3048530012, 3048610017, 3048610027,
          3048670038, 3048880001, 3048990053, 3049130001, 3049150053,
          3049180014, 3050260154, 3050280001, 3050650054, 3050650061,
          3050850096, 3051660027, 3052370020, 3052460001, 3053530067,
          3053530068, 3055900074, 3055910018, 3056730037, 3056860032,
          3057010026, 3057070059, 3057280007, 3057550050, 3057600007,
          3057620021, 3057700059, 3057800029, 3057890048, 3058550029,
          3058550054, 3058560021, 3058570012, 3058590141, 3058620004,
          3058640033, 3059310041, 3059620018, 3059810046, 3059830001,
          3060090020, 3060090021, 3060090069, 3060440049, 3060490030,
          3060850047, 3061330025, 3061850043, 3062070021, 3062170069,
          3062840061, 3062960018, 3062960019, 3063160006, 3063960005,
          3065650052, 3066120042, 3066780122, 3067060014, 3067660086,
          3067770012, 3068510020, 3068770065, 3070260047, 3071820031,
          3073460063, 3073490071, 3076990046, 3082350315, 4034860049,
          4034860063, 3086880078, 4000300049, 4001700037, 4001710044,
          4001710051, 4001920035, 4001930011, 4001930018, 4001940045,
          4002020052, 4003240046, 4003400042, 4005150001, 4005330025,
          4005440039, 4005480030, 4005730053, 4005767501, 4005830036,
          4005850045, 4005980025, 4006080046, 4006100033, 4006200194,
          4006230137, 4006240055, 4006330012, 4006330013, 4006530096,
          4006550072, 4006740008, 4006910006, 4006960113, 4007230132,
          4007230133, 4007290017, 4007340009, 4007340015, 4007340034,
          4007390055, 4007390056, 4007400032, 4007400034, 4034890045,
          4007830036, 4007840004, 4008200030, 4008410054, 4009010018,
          4012380004, 4012380062, 4012630001, 4012750045, 4012820044,
          4013100013, 4013140035, 4013140038, 4013160038, 4013300014,
          4013300025, 4013300033, 4013330066, 4013680025, 4015180044,
          4015277502, 4016080040, 4016990043, 4017060001, 4017340042,
          4017420027, 4017440024, 4017470090, 4017510033, 4017530026,
          4017550061, 4017670001, 4017710031, 4017750019, 4019060026,
          4019060128, 4019060129, 4019127501, 4019990068, 4021000021,
          4021350050, 4021390001, 4021510127, 4022910018, 4022910019,
          4022910043, 4023980080, 4028680025, 4030580043, 4033220024,
          4033220156, 4033397501, 4033940054, 4033940056, 4034040006,
          4034050007, 4034320022, 4034320052, 4034330020, 4034370050,
          4034480058, 4034500054, 4034520044, 4034530010, 4034560054,
          4034620035, 4034630033, 4034630048, 4034650014, 4034660021,
          4034720020, 4034720040, 4034950011, 4035380025, 4035460082,
          4035540077, 4035540078, 4035740021, 4035750006, 4035750019,
          4035750020, 4036190066, 4036190068, 4036440006, 4036440007,
          4036450011, 4036450043, 4036880012, 4036980021, 4036980022,
          4036980023, 4037010013, 4037880109, 4045880038, 4045880052,
          4046020120, 4046030019, 4049550029, 4050080031, 4050130063,
          4050130065, 4050390021, 4051040004, 4051850078, 4053180006,
          4053950028, 4059380005, 4064850003, 4065740030, 4067980004,
          4084010096, 4084400001, 4084420001, 4084890001, 4097020076,
          4108190001, 5000620011, 5010050019, 5031910061, 3018980010,
          3050860030, 1020250034, 1020250056, 1020250058, 2023090026,
          2025827501, 3013130053, 3013780070, 3030370010, 3030520019,
          3050860034,
        ].includes(bbl)
      ? "0616"
      : "0606";
  } else {
    return [
      4031550001, 4045880036, 4045910066, 4061490001, 4061500001, 4066560063,
      4077480500, 4084430001, 1005730043, 1009150046, 1009210019, 1009280001,
      1009300001, 1012080052, 1013330023, 1013630031, 1013630040, 1013630043,
      1014480003, 1015080038, 1015120123, 2055170061, 2055170132, 2057430002,
      2057470590, 2058000001, 2059500475, 3020610060, 3020610080, 3050430086,
      3072380049, 3073980002, 3077780024, 3077800008, 3087210360, 4012650030,
      4012650033, 4015470001, 4020860050, 4020930001, 4020930245, 4021000021,
      4021010001, 4021010016, 4021010024, 4021480001, 4021620122, 4021860002,
      4022370001, 4033120008, 4033220024, 4033220156, 4034710008, 4045880001,
      4045880023, 4045880024, 4045880038, 4045880051, 4045880052, 4045910075,
      4045910082, 4045910083, 4045910096, 4045910103, 4045910109, 4045910118,
      4045910129, 4046020030, 4046020034, 4046020120, 4046020125, 4046020131,
      4046030002, 4046030018, 4046030019, 4046030032, 4046030034, 4046030048,
      4053140003, 4059380007, 4060890025, 4061430001, 4064820003, 4064820100,
      4064840002, 4064850003, 4064930003, 4064940003, 4065370028, 4065400003,
      4065420003, 4065740030, 4066070001, 4066090007, 4066280001, 4066900016,
      4071170401, 4077320002, 4077320150, 4077380001, 4077390003, 4077420003,
      4077480400, 4077540003, 4077550003, 4079120050, 4084010096, 4084010350,
      4084010675, 4084400001, 4084420001, 4084460001, 4084500001, 4084890001,
      4087620001, 4097580021, 4114460012, 4114460050,
    ].includes(bbl)
      ? "0623"
      : bbl === 1017230023
      ? "0608"
      : "0603";
  }
};
